import * as z from "zod/v4";
import { MarketingAgentAnalyticsInputSchema_ } from "./common";

const TagDistributionItemSchema = z.object({
  tag: z.string(),
  count: z.number(),
});

export const getMarketingAgentTagDistribution = {
  name: "getMarketingAgentTagDistribution" as const,
  input: MarketingAgentAnalyticsInputSchema_.extend({
    action: z.enum(["proceed", "skip", "reevaluate"]),
    limit: z.number().int().positive().default(10),
  }),
  output: z.array(TagDistributionItemSchema),
};
